
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	TouchableOpacity,
	StyleSheet,
	View,
} from "react-native";
import noop from "noop3";

import Style from "ae-style";

import StyledText from "./StyledText";
import StyledIcon from "./StyledIcon";

import { useIdPrefix } from "@aetonix/hooks";

const styles = StyleSheet.create({
	button: {
		margin: Style.layout.marginSmall / 2,
		width: Style.layout.squareButton,
		height: Style.layout.squareButton,
	},
	icon: {
		justifyContent: "center",
		alignItems: "center",
		flex: 8,
	},
	text: {
		flex: 8,
		paddingHorizontal: Style.layout.paddingSmall,
	},
	fit: {
		flex: 1,
	},
	centerText: {
		textAlign: "center"
	},

	contrastBackground: {
		backgroundColor: Style.look.contrast.sectionBackground,
	},
	lightBackground: {
		backgroundColor: Style.look.sectionBackground,
	},
	secondaryBackground: {
		backgroundColor: Style.look.secondaryBackground,
	},
	alertBackground: {
		backgroundColor: Style.look.alert
	},

	disabled: {
		opacity: Style.look.disabled,
	},
});

/**
	This function takes the following props:
		contrast - object
		text - string
		title - string
		onPress - function
		secondary - object
		clear - boolean?
		disabled - boolean
		alert - boolean?
		textSize - a number in size pixels (px)
		iconSize - a number OR a named style from Style.js
		style - style that gets added to the stylelist
**/

export default function SquareButton(props){
	const idPrefix = useIdPrefix();
	let onPress = props.onPress;
	const title = props.title || "";

	const contrast = props.contrast;
	const secondary = props.secondary;
	const clear = props.clear;
	const disabled = props.disabled;
	const alert = props.alert;
	const textSize = props.textSize;
	const iconSize = props.iconSize;
	const text = props.text;
	const secondaryText = props.secondaryText;
	const secondaryTitle = props.secondaryTitle || "";
	const displayCentered = props.displayCentered;

	let styleList = [styles.button, styles.lightBackground];
	let isContrastText = false;

	if(clear){
		isContrastText = !!contrast;
		styleList = [styles.button];
	} else	if(contrast){
		isContrastText = true;
		styleList = [styles.button, styles.contrastBackground];
	} else if(secondary){
		isContrastText = true;
		styleList = [styles.button, styles.secondaryBackground];
	} else if(alert){
		isContrastText = true;
		styleList = [styles.button, styles.alertBackground];
	}

	const iconName = props.icon || "question";

	const display2 = (secondaryText !== undefined && secondaryText !== null) ? (
		<StyledText size={iconSize} centered={displayCentered}>
			{secondaryText}
		</StyledText>
	) : null;

	// if text is undefined or null, display a question mark
	const display = (text !== undefined && text !== null) ? (
		<View style={styles.icon}>
			<StyledText size={iconSize} centered={displayCentered}>
				{text}
			</StyledText>
			{display2}
		</View>
		) : (
			<View style={styles.icon}>
				<StyledIcon name={iconName} contrast={isContrastText} size={iconSize} />
			</View>
		);

	if(disabled){
		onPress = noop;
		styleList.push(styles.disabled);
	}

	styleList.push(props.style);

	// To explicitly control text size and icon size
	let styleText = styles.centerText;
	if (textSize && typeof textSize === "number") {
		styleText = [styleText].concat({
			fontSize: textSize
		});
	}

	const children = props.children;

	const secondaryTitleDisplay = secondaryTitle ? (
		<StyledText testID={props.id + "_text"} small bold black compact contrast={isContrastText} style={styleText}>
			{secondaryTitle}
		</StyledText>
	) : null;

	return (
		<TouchableOpacity testID={`${idPrefix}${idPrefix ? "-" : ""}${props.id}`} accessibilityComponentType="button" style={styleList} onPress={onPress}>
			<View style={styles.fit}>
				{children}
				{display}
				<View style={styles.text}>
					<StyledText testID={props.id + "_text"} small bold black compact contrast={isContrastText} style={styleText}>
						{title}
					</StyledText>
					{secondaryTitleDisplay}
				</View>
			</View>
		</TouchableOpacity>
	);
}